module.exports = __webpack_public_path__ + "img/stop-call.932d606.svg";